import React from 'react'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { FaBan } from 'react-icons/fa'


interface Props {
  signalLevel: number | null
}


const SignalIcon = ({ signalLevel }: Props) => {
  let className: string | null
  if (signalLevel === null) {
    className = null
  } else if (signalLevel >= 21) {
    className = 'good four-bars'
  } else if (signalLevel >= 15 && signalLevel < 21) {
    className = 'ok three-bars'
  } else if (signalLevel >= 10 && signalLevel < 15) {
    className = 'bad two-bars'
  } else if (signalLevel > 0 && signalLevel < 10) {
    className = 'vbad one-bar'
  } else {
    className = 'no-bars'
  }
  return (
    <span>
       <OverlayTrigger
         delay={{ hide: 450, show: 300 }}
         overlay={(props: any) =>
           <Tooltip {...props}>{`CSQ: ${signalLevel !== null ? signalLevel : 'not available'}`}</Tooltip>}
         placement="bottom"
       >
         {signalLevel !== null
           ?
           <div className={`signal-bars mt1 sizing-box good four-bars ${className}`}>
             <div className="first-bar bar"></div>
             <div className="second-bar bar"></div>
             <div className="third-bar bar"></div>
             <div className="fourth-bar bar"></div>
           </div>
           : <span><FaBan /></span>}
        </OverlayTrigger>
      </span>
  )
}

export default SignalIcon
